import { Routes } from '@/routes';

export default {
	'domain-setup.domain-setup-awardforce': () => import('@/modules/domain-setup/index'),
	'domain-setup.domain-setup-goodgrants': () => import('@/modules/domain-setup/index'),
} as Routes;
